import AppContent from 'components/app-layout/Content';

import Routes from './Routes';
import Sidebar from './Sidebar';

export default function AdminLayout() {
  return <AppContent>
    <Sidebar />
    <Routes />
  </AppContent>
}
